import { Link } from 'react-router-dom';

/**
 * Display a featured post.
 * 
 * @param {Object} post - The post content.
 * @returns A `featured-post` div.
 * 
 * @updated May 28, 2025.
 */

const BlogPostFeaturedCard = ({ post }) => {
  return (
    <div className="featured-post">
      <Link to={`/blog/post/${post.slug}`} className="featured-post-image">
        <img src={post.image} alt={post.title} />
      </Link>
      <div className="featured-post-content">
        <div className="post-meta">
          <span className="post-category">{post.category}</span>
          <span className="post-date">{post.date}</span>
        </div>
        <h2>
          <Link to={`/blog/post/${post.slug}`}>{post.title}</Link>
        </h2>
        <p className="post-excerpt">{post.excerpt}</p>
        <Link to={`/blog/post/${post.slug}`} className="read-more">
          Read More
        </Link>
      </div>
    </div>
  );
};

export default BlogPostFeaturedCard;
